module.exports = __webpack_public_path__ + "static/media/empathy_background.1d3f25a7.png";